import type { LocaleOption } from './types';

export const LOCALE_KEY = 'axa-locale';

export const longLocaleOptions: LocaleOption[] = [
  {
    label: 'Português',
    value: 'pt-BR'
  },
  {
    label: 'English',
    value: 'en'
  },
  {
    label: 'Français',
    value: 'fr'
  }
];

export const shortLocaleOptions: LocaleOption[] = [
  {
    label: 'PT-BR',
    value: 'pt-BR'
  },
  {
    label: 'EN',
    value: 'en'
  },
  {
    label: 'FR',
    value: 'fr'
  }
];
